<template>
<div class="widthFull h-100 back-1">
      <CONTATORE v-if="checkAccessOk && type == 'CONTATORE'"  />
      <SOGLIAPREMIOFISICO v-if="checkAccessOk && type == 'SOGLIA_PREMIOFISICO'"  />
   </div>
   
</template>


<script>
import { mapGetters, mapState } from "vuex";
import { BadgerAccordion, BadgerAccordionItem } from "vue-badger-accordion";
import axios from "axios";
import CONTATORE from "./template_contatore"
import SOGLIAPREMIOFISICO from "./template_soglia_premiofisico.vue"
import { USER_REQUEST } from "actions/user";
import Vue from "vue";
import { VueSvgGauge } from "vue-svg-gauge";
import "vue-select/dist/vue-select.css";
import "viewerjs/dist/viewer.css";

const moment = require("moment");

export default {
  name: "contest",
  components: {
    BadgerAccordion,
    BadgerAccordionItem,
    VueSvgGauge,
    CONTATORE,
    SOGLIAPREMIOFISICO

  },
  props: {
    pageTitle: {
      type: String,
      default: "Contest",
    },
  },
  data() {
    return {
      loadingState: "",
      moment: moment,
      statusPlay: {},
      contests: {},
      type :'',
      id: "",
      piva: "",
      title: "",
      title: "",
      contest: true,
      endRec: "",
      info: false,
      checkAccessOk: false,
      main_image: "",
      main_text: "",
      regulation: "",
      time: false,
      $viewer: "",
      vw: window.innerWidth,
      countdown: 0,
      datenow: "",
      finish: false,
      cod_client: "",
      products: [],
      start: "",
      end: "",
      start_: "",
      end_: "",
      award_spec: "",
      id: "",
      award_image: "",
      empty: true,
      minProduct: "",
      minPrice: "",
      regex: "",
      playContest: "",
      selectedPlay: {},
      my_registration_in_promo: 0,
      maxRegistration: 0,
      playConsens: true,
      maxRegistrationOr: 0,
      now: moment(),
      maxRegistration_: 0,
      step: require("../../assets/images/step.png"),
      doc: require("../../assets/images/doc.png"),
    };
  },
  methods: {
    setProfileData: function () {
      this.piva = this.profile.piva;
      this.email = this.profile.email;
      this.name = this.profile.ACname;
      this.lastname = this.profile.ACsecondname;
      this.userToken = this.profile.id;

      this.company = this.profile.company;
      this.phone = this.profile.phone;
      this.role = this.profile.role;
      this.iban = this.profile.iban;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      this.cod_client = this.profile.cod;
      
      this.group = this.profile.groupPh;
      this.profileId = this.profile.id;
    },
    checkAccess: async function () {
      if (this.piva == this.$route.params.piva) {
        this.$track("checkAccess", "START");
        var data = {
          id: this.$route.params.id,
          piva: this.$route.params.piva,
          cod: this.$route.params.cod,
          group: this.group,
          profile: this.profile,
          id_platform: process.env.ID_PLATFORM,
          unique_key_db: process.env.UNIQUE_KEY_DB,
          vector_unique_key_db: process.env.ICODE,
        };
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        await axios({
          method: "POST",
          data: { data },
          url: process.env.ROOT_API + "api/checkAccess",
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
            this.loadingState = false;
            this.checkAccessOk = true;
            this.$track("checkAccess", "SUCCESS");
            this.$track("checkAccess", resp.data);
            if (resp.data == "access_denied") {
              this.message =
                '<b class="Bold">Non hai accesso a questa promozione</b>';
              this.UploadError("", this.message);
            } else {
            }
          })
          .catch((err) => {
            this.loadingState = false;
            this.$track("checkAccess", "ERROR");
            err.response.data = this.$decryptByAES(
              err.response.data,
              process.env.CRYPTKEY
            );
          });
      } else {
        this.$router.push("/");
      }
    },
      trackAccess: async function () {
      this.loadingState = true;
      this.$track("trackAccess", "START");
      var data = {
        promotion_id_track: this.$route.params.id,
        client_piva_track: this.$route.params.piva,
        client_cod_track: this.$route.params.cod,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/trackAccess",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.$track("trackAccess", "SUECCESS");
          var prod = [];
          for (var x in resp.data) {
            var y = [];
            y["key"] = x;
            y["label"] = resp.data[x];
            prod.push(y);
          }
          this.products = prod;
          this.loadingState = false;
        })
        .catch((resp) => {
          this.loadingState = false;
          this.$track("trackAccess", "ERROR");
        });
    },
    getThisContest: async function () {
      this.loadingState = true;
      this.$track("getThisContest", "START");
      var data = {
        id: this.$route.params.id,
        status: "ACTIVE",
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/getThisContest",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.loadingState = false;
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          this.$track("getThisContest", "SUCCESS");
          if (resp.data) this.empty = false;
          else this.getThisContestNOTACTIVE()
          for (var i in resp.data) {
            var pass = JSON.parse(resp.data[i].config);
            resp.data[i].config = pass;
          }
          if (resp.data){
             this.trackAccess();
          this.contests = resp.data[0];
          this.type = this.contests.config.TIPOLOGIA_RIEPILOGO
          this.start_ = this.contests.start;
          this.start = moment(this.start_).format("DD-MM-YYYY");
          this.end_ = this.contests.end;
          this.end = moment(this.end_).format("DD-MM-YYYY");

          this.now = moment();
          var then = moment(this.end_);

          var dif = then.diff(this.now);
          if (dif <= 0) {
            this.finish = true;
            this.countdown = 0 - dif;
          } else {
            this.countdown = dif;
          }
          this.$track("getThisContest", this.contests);
          }
          
        })
        .catch((err) => {
          this.loadingState = false;
          err.response.data = this.$decryptByAES(
            err.response.data,
            process.env.CRYPTKEY
          );
          this.$track("getThisContest", "ERROR");
        });
    },
    getThisContestNOTACTIVE: async function () {
      this.loadingState = true;
      this.$track("getThisContestNOTACTIVE", "START");
      var data = {
        id: this.$route.params.id,
        status: "ENDED",
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/getThisContest",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.loadingState = false;
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          this.$track("getThisContestNOTACTIVE", "SUCCESS");
           this.trackAccess();
          if(!resp.data){
            
          }
          if (resp.data) {
            this.empty = false;
          }
          for (var i in resp.data) {
            var pass = JSON.parse(resp.data[i].config);
            resp.data[i].config = pass;
          }
          this.contests = resp.data[0];
          this.type = this.contests.config.TIPOLOGIA_RIEPILOGO
          this.start_ = this.contests.start;
          this.start = moment(this.start_).format("DD-MM-YYYY");
          this.end_ = this.contests.end;
          this.end = moment(this.end_).format("DD-MM-YYYY");

          this.now = moment();
          var then = moment(this.end_);

          var dif = then.diff(this.now);
          if (dif <= 0) {
            this.finish = true;
            this.countdown = 0 - dif;
          } else {
            this.countdown = dif;
          }
          this.$track("getThisContestNOTACTIVE", this.contests);
        })
        .catch((err) => {
          this.loadingState = false;
          err.response.data = this.$decryptByAES(
            err.response.data,
            process.env.CRYPTKEY
          );
          this.$track("getThisContestNOTACTIVE", "ERROR");
        });
    },
    
  },
  /********************************************************************************************* */
  watch: {
    getProfile: function (val) {
      this.setProfileData();
      this.checkAccess();
    },
    "$route.params.id": {
      handler: function (id) {
        if (this.loaded) {
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.params.piva": {
      handler: function (id) {
        if (this.loaded) {
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.params.cod": {
      handler: function (id) {
        if (this.loaded) {
        }
      },
      deep: true,
      immediate: true,
    },
    /**************** */
    selectedPlay: function (array) {
      this.imageLoaded = true;
    },
    info: function () {
      if (this.info) {
        var _vue = this;
        setTimeout(function () {
          _vue.$refs.activeAccordion.open(0);
        }, 100);
      }
    },
    /**************** */
  },

  mounted: function () {
    this.id = this.$route.params.id;
    var piva = this.$route.params.piva;
    var cod = this.$route.params.cod;
    if (!cod) {
      this.$router.push("/");
    }
    if (!piva) {
      this.$router.push("/");
    }

    if (this.getProfile.piva) {
      this.setProfileData();
      this.getThisContest();
      this.checkAccess();
      this.now = moment().format("DD-MM-YYYY");
    }

    window.onresize = () => {
      this.vw = window.innerWidth;
      this.vh = window.innerHeight;
    };
    var _vue = this;
    setTimeout(function () {
      _vue.$scrollTo("#top", 0, { offset: -125 });
    }, 100);
  },
  created: async function () {
    await this.getThisContest();
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "isAuthenticated",
      "isProfileLoaded",
      "acceptCookies",
    ]),
    ...mapState({
      authLoading: (state) => state.auth.status === "loading",
      profile: (state) => state.user.profile,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/contest/index.vue